interface WaveformVisualizerProps {
  amplitudes: number[];
  isActive: boolean;
  barCount?: number;
}

export function WaveformVisualizer({
  amplitudes,
  isActive,
  barCount = 30,
}: WaveformVisualizerProps) {
  const bars = Array.from({ length: barCount }, (_, i) => {
    const amp = amplitudes[amplitudes.length - barCount + i] ?? 0;
    return Math.max(0.05, amp);
  });

  return (
    <div className="flex items-center justify-center gap-0.5 h-12 w-full">
      {bars.map((amp, i) => (
        <div
          key={i}
          className={`w-1 rounded-full transition-all duration-75 ${
            isActive ? 'bg-red-500' : 'bg-muted-foreground/40'
          }`}
          style={{ height: `${Math.round(amp * 100)}%`, minHeight: '4px' }}
        />
      ))}
    </div>
  );
}
